module.exports = __webpack_public_path__ + "img/email.37e7603d.svg";